/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useFlags, withLDProvider } from 'launchdarkly-react-client-sdk';
import { I18nextProvider } from 'react-i18next';

import { CLIENT_SIDE_ID } from './constants';
import { getLDRelayURL } from './utils/getLDRelayURL';
import i18next from './i18n/index';
import { CreateAttendance, ListAttendance, CompanyProposal } from './containers';

const launchDarklyURL = getLDRelayURL(window.location.hostname, window.location.origin);

interface AppProps {
  componentType?: any;
}

const App = ({ componentType }: AppProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const { apiDomain } = useFlags();
  const getComponent = {
    list: <ListAttendance />,
    create: <CreateAttendance />,
    companyProposal: <CompanyProposal />,
  } as any;

  useEffect(() => {
    if (apiDomain) {
      setLoading(false);
    }
  }, [apiDomain]);

  if (loading) {
    return <></>;
  }

  return (
    <div className="vbz-lf" data-testid="vbz-attendance">
      <I18nextProvider i18n={i18next}>{getComponent[componentType]}</I18nextProvider>
    </div>
  );
};

export default withLDProvider<AppProps>({
  clientSideID: CLIENT_SIDE_ID,
  user: { key: launchDarklyURL.ldUser },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  options: {
    baseUrl: launchDarklyURL.url,
  },
})(App);

App.defaultProps = {
  componentType: 'list',
};
